module.exports = __webpack_public_path__ + "media/img/pages/companies/allianz-984a0888a11a0f62ba96c175982c335a.jpg";